import React from "react";
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QueryBuilderValueBox } from "components/queries/queryBuilder/common/QueryBuilderValueBox";
import { QueryField, QueryInfo } from "system/query/QueryInfo";
import { QueryBuilderInnerLabel } from "../../common/QueryBuilderInnerLabel";

export interface MultiValueViewerProps {
  value: string | number | boolean | null | undefined;
  values: (string | number | boolean | null | undefined)[] | undefined;

  label?: string;
  labels?: string[];

  queryInfo: QueryInfo;
  field: QueryField;
  borderColor: string;
  borderColorTop?: string;

  isViewerMode?: boolean;

  maxValuesToDisplay?: number;
  maxValuesOverlap?: number;
}

export default function MultiValueViewer(props: MultiValueViewerProps): JSX.Element {
  const theme = useTheme();
  const {i18n} = useTranslation();

  let values = props.values?.length ? [...props.values] : (props.value !== undefined ? [props.value] : []);
  if (props.field?.type === "boolean") {
    values = [props.value ? true : false];
  }

  const totalValues = values?.length;
  const labels = props.labels || [props.label] || [];

  const maxValuesToDisplay = props.maxValuesToDisplay || 20;
  const maxValuesCutOff = maxValuesToDisplay + (props.maxValuesOverlap || 0);
  if (totalValues > maxValuesCutOff) {
    values = values.slice(0, maxValuesToDisplay);
  }

  const valueDisplay = !!values?.length && values.map((value, index) => {
    const label = labels && labels.length > index && labels[index] || undefined;

    return (
    <Box key={index} sx={{display:"inline"}}>
      <QueryBuilderValueBox
        queryInfo={props.queryInfo}
        selectedField={props.field}
        borderColor={props.borderColor}
        borderColorTop={props.borderColorTop}
        inline={true}
        isViewerMode={props.isViewerMode}
        value={value}
        label={label as string}
        key={index} />
        {(totalValues > 1 && index < totalValues - 1) &&
          <QueryBuilderInnerLabel>or</QueryBuilderInnerLabel>
        }
    </Box>
    );
  });


  return (
    <>
      {valueDisplay}
      {(!!values.length && values.length < totalValues) &&
        <Box sx={{display:"inline"}}>
          <QueryBuilderValueBox
            borderColor={props.borderColor}
            borderColorTop={props.borderColorTop}
            inline={true}
            isViewerMode={props.isViewerMode}
            overrideContent={true}>
            <Box sx={{ display: "inline", fontWeight:"bold", color: theme.colors.namedColors.chart2 }}>{`+ ${totalValues - values.length} ${i18n.t("additional_entries")}`}</Box>
          </QueryBuilderValueBox>
        </Box>
      }
    </>
  );
}